import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { Stop, Stops } from '../../../../@core/models/live-route';
import { LiveRouteStatus } from '../../../../@core/models/live-route-status';
import {
  AddExceptionDialogComponent,
  OptimizeDialogComponent
} from '../../../../@theme/components';
import { DashboardBase } from '../dashboard.base';
import { concat, interval, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentPortal } from '@angular/cdk/portal';
import { ProgressSpinnerComponent } from '../../../../@theme/components/progress-spinner/progress-spinner.component';
import { DTOOptimizationResult } from '../../../../@core/models/dto-optimizationresult';
import { OptimizeresultDialogComponent } from '../../../../@theme/components/optimizeresult-dialog/optimizeresult-dialog.component';
import { TransfertSectorDialogComponent } from '../../../../@theme/components/transfert-sector-dialog/transfert-sector-dialog.component';
import { ChangePriorityModalComponent } from '../../../../@theme/components/change-priority-modal/change-priority-modal.component';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel
} from '../../../../@theme/components/confirm-dialog/confirm-dialog.component';
import { TransfertDateDialogComponent } from '../../../../@theme/components/transfert-date-dialog/transfert-date-dialog.component';
import { ClientsModalComponent } from '../../../../@theme/components/clients-modal/clients-modal.component';
import { mergeMap } from 'rxjs/operators';
import { ENotificationType } from '../../../../@core/models/e-notification-type';
import { CreatePickupComponent } from '../../../../@theme/components/create-pickup/create-pickup.component';
import { SectorService } from '../../../../@core/services/sector.service';
import { GeoTabUser } from '../../../../@core/models/geoab-user';
import { SelectGeotabUser } from '../../../../@theme/components/select-geotab-user/select-geotab-user.component';
import { RouteEndpointsDialogComponent } from '../route-endpoints-dialog/route-endpoints-dialog.component';

export interface DialogData {
  message: '';
}

@Component({
  selector: 'ngx-actionbar',
  templateUrl: './actionbar.component.html',
  styleUrls: ['./actionbar.component.scss']
})
export class ActionBarComponent
  extends DashboardBase
  implements OnInit, DashboardBase {
  public dialog: MatDialog;
  public localData: [];
  public sub: Subscription;
  private optDialogRef: MatDialogRef<OptimizeDialogComponent, any> = null;
  public CurrentDate: Date = new Date();
  public routeLocked: boolean = false;
  geotabUsers: Array<GeoTabUser>;

  ngOnInit() {

    /*this.sub = this._stopService.dataNotOptimized.subscribe(res => {
      if (res) {
        if (this.optDialogRef === null) {
          this.optDialogRef = this.dialog.open(OptimizeDialogComponent);
          this.optDialogRef.afterClosed().subscribe(() => {
            this.optDialogRef = null;
          });
        }
    });*/
    this.sub = this._stopService.routeHasBeenLocked.subscribe((res) => {
      this.routeLocked = res;
    });
  }

  public onClickAddException() {
    const dialogRef = this.dialog.open(AddExceptionDialogComponent, {
      height: '400px',
      width: '600px'
    });
  }

  public onClickPrintRoute() {
    this._stopService
      .getPrintRoutePDF(this._stopService.RouteID, this._stopService.RouteDate)
      .subscribe((data) => {
        const blob = new Blob([data as BlobPart], { type: 'application/pdf' });
        this.showAndDownloadRoutePDF(blob);
      });
  }

  private showAndDownloadRoutePDF(blob: Blob) {
    const fileName =
      'route_' +
      this._stopService.RouteID +
      '_' +
      this.datePipe.transform(this._stopService.RouteDate, 'yyyy-MM-dd') +
      '.pdf';
    const downloadURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = fileName;
    link.click();
    window.open(downloadURL); // This is blocked by adblock so we also need to download
  }
  private async sleepExample() {
    await this.delay(1000);
  }
  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public onClickCreatePickup() {
    const dialogRef = this.dialog.open(CreatePickupComponent, {
      height: '400px',
      width: '600px'
    });
  }

  public async onClickPrintPickupLabels() {
    const shippingIds = [];
    const addresses = [];
    this._stopService.currentStopsValue.StopsList.filter(
      (p) =>
        (p.ShippingType === 1 &&
          p.ParcelCompress[0].Live_Route_Type === 1 &&
          p.NO_PICKUP_LABEL_PRINTING_TPSLROUTE === false) || p.ParcelCompress[0].Live_Route_Type === 31
    )
      .sort((x) => x.No_Stop)
      .reverse()
      .forEach((x) => {
        x.ParcelCompress.forEach((y) => {
          const shippindId = Math.floor(y.Parcel_ID / 100);
          if (!shippingIds.includes(shippindId)) {
            shippingIds.push(shippindId);
          }
        }
        )
        //shippingIds.push(x.Shipping_ID);
        addresses.push(x.Address.Address1);
      });
    console.log(shippingIds);
    this.labelService.printLabels(shippingIds).subscribe(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.log(error);
      }
    );
    /*
    const pickupIds = this._stopService.dataSource.data
      .filter((p) => {
        return (
          p.ShippingType === 1 && p.ParcelCompress[0].Live_Route_Type === 1
        );
      })
      .map((p) => p.Shipping_ID);
    if (this._stopService.dataSource) {
      if (pickupIds.length === 0)
        this.notify.info(
          this.translate.instant('overlay-stoplist-buttons.NoPickups')
        );
      else {
        for (let pickupId of pickupIds) {
          this.labelService.printLabels(pickupId).subscribe((result) => {});
        }
        this.notify.info(
          this.translate.instant('overlay-stoplist-buttons.PrintPickupsSuccess')
        );
      }
    } else {
      this.notify.info(
        this.translate.instant('overlay-stoplist-buttons.NoPickups')
      );
    }*/
  }

  addClient() {
    const dialogRef = this.dialog.open(ClientsModalComponent, {
      height: '380px',
      width: '400px'
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  onClickChangeAddress() {
    if (this._stopService.selectedStops.length === 1) {
      this.ChangeAddress(this._stopService.selectedStops[0]);
    }
  }

  transferDate() {
    const dialogRef = this.dialog.open(TransfertDateDialogComponent, {
      height: '400px',
      width: '400px'
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  transferSector() {
    const dialogRef = this.dialog.open(TransfertSectorDialogComponent, {
      height: '550px',
      width: '400px'
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  public onClickPrintSelectedLabels() {
    let SelectedShippingId: Stop[] = [];

    SelectedShippingId = this._stopService.selectedStops;

    if (SelectedShippingId.length === 0)
      this.notify.info('Impression: Aucun envoi');
    else {
      for (const onestop of SelectedShippingId) {
        this.labelService
          .printLabels([onestop.Shipping_ID])
          .subscribe((result) => { });
      }
      this.notify.info("Impression: Étiquettes envoyées à l'imprimante");
    }
  }

  public lockRoute() {
    this.apiProvider
      .UpdateLiveRouteStatusLocked(
        this._stopService.currentStopsValue.Route_ID,
        this.authenticationService.currentUserValue.UserID,
        this._stopService.RouteDate,
        !this._stopService.currentStopsValue.HasBeenLocked
      )
      .subscribe((result) => {
        this._stopService.currentStopsValue.HasBeenLocked =
          !this._stopService.currentStopsValue.HasBeenLocked;
      });
  }

  public onHoldClick() {
    this.BatchmoveToOnHold(this._stopService.selectedStops, 1);
  }

  public onClickSetLastStop() {
    this.setLastStop(this._stopService.RouteID);
  }

  public sendUpdateNotification() {
    this.apiProvider.sendNotification("Mobile", ENotificationType.update, this._stopService.RouteID).subscribe(
      (res) => {
      },
      (err) => {
      }
    )
  }

  public ChangePriority() {
    const dialogRef = this.dialog.open(ChangePriorityModalComponent, {
      height: '600px',
      width: '600px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      this._stopService.initialiseRoute();
    });
  }

  public confirmOptimizeRoute(_version: string) {
    const routeId = this._stopService.RouteID;
    const routeDate = new Date(this._stopService.RouteDate.getTime());
    const routeDateKey = this.datePipe.transform(routeDate, 'yyyy-MM-dd');
    const stops = this._stopService.currentStopsValue;
    const stopCount = stops && stops.StopsList ? stops.StopsList.length : undefined;
    const dialogRef = this.dialog.open(RouteEndpointsDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      data: {
        routeId,
        routeDate,
        stopCount
      }
    });
    dialogRef.afterClosed().subscribe(optimize => {
      if (optimize === true) {
        if (this._stopService.RouteID !== routeId ||
            this.datePipe.transform(this._stopService.RouteDate, 'yyyy-MM-dd') !== routeDateKey) {
          this.toastrService.warning(this.translate.instant('route-endpoints.selection-changed'));
          return;
        }
        this.OptimizeRoute();
      }
    });

  }

  public OptimizeRoute() {
    this._stopService.setLoadingInProgress(true);
    ProgressSpinnerComponent;
    this.OptimService.OptimizeRouteApiV5(
      this._stopService.RouteDate,
      this._stopService.RouteID
    ).subscribe(
      (success: boolean) => {
        this._stopService.initialiseRoute();
      },
      (err: HttpErrorResponse) => {
        this._stopService.initialiseRoute();
        this._stopService.setLoadingInProgress(false);
        this._stopService.currentStopsSubject.next(null);
      }
    );
    /*
        this.OptimService.ReoptimizeRoute(
          this._stopService.RouteDate,
          this._stopService.RouteID.toString()
        ).subscribe(
          (optimizationResult: DTOOptimizationResult) => {
            this._stopService.selectedRouteTotalDistance = Math.trunc(optimizationResult.TotalDistance);
            this._stopService.setLoadingInProgress(false);
            this._stopService.currentStopsSubject = new BehaviorSubject<Stops>(
              optimizationResult.Stops
            );
            this._stopService.currentStops =
              this._stopService.currentStopsSubject.asObservable();
            this._stopService.dataSource = new MatTableDataSource<Stop>(
              this._stopService.currentStopsValue.StopsList
            );
            this.agmGoogleMapService.setPolyline(
              optimizationResult.Stops.RoutePolylines
            );
            if (optimizationResult.IsError) {
              const dialogRef = this.dialog.open(OptimizeresultDialogComponent, {
                data: { message: optimizationResult.ErrorMessage }
              });
            } else {
              this._stopService.HideETACalculation = false;
              const dialogRef = this.dialog.open(OptimizeresultDialogComponent, {
                data: { message: 'Optimisation Complétée' }
              });
            }
          },
          (err: HttpErrorResponse) => {
            this._stopService.setLoadingInProgress(false);
            this._stopService.currentStopsSubject.next(null);
          }
        );
        */
  }

  public OptimizeRouteV3() {
    this._stopService.setLoadingInProgress(true);
    ProgressSpinnerComponent;

    this.OptimService.ReoptimizeRoute(
      this._stopService.RouteDate,
      this._stopService.RouteID.toString()
    ).subscribe(
      (optimizationResult: DTOOptimizationResult) => {
        if (optimizationResult.IsError) {
          this._stopService.setLoadingInProgress(false);
          const dialogRef = this.dialog.open(OptimizeresultDialogComponent, {
            data: { message: optimizationResult.ErrorMessage }
          });
        } else {
          this._stopService.HideETACalculation = false;
          this._stopService.initialiseRoute();
          const dialogRef = this.dialog.open(OptimizeresultDialogComponent, {
            data: { message: 'Optimisation Complétée' }
          });
        }
      },
      (err: HttpErrorResponse) => {
        this._stopService.setLoadingInProgress(false);
        this._stopService.currentStopsSubject.next(null);
      }
    );
  }

  onClickGeoTab() {

    if (this._stopService.RouteID) {
      let data = {
        rId: this._stopService.RouteID,
        geoTabUserId: "test"
      }

      const dialogRef = this.dialog.open(SelectGeotabUser, {
        height: '500px',
        width: '600px',
        data: data
      });
    }

  }
}
